

















import {
  Component,
  Prop,
  Mixins,
  Emit,
} from 'vue-property-decorator';
import FormMixin from '../../../common/mixins/formMixin';

@Component
export default class FitSwitch extends Mixins(FormMixin) {
  @Prop({
    type: Boolean,
    default: false,
  })
  checked!: boolean;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled!: boolean;
  @Emit('change')
  bindChange() {}
  @Emit('switch')
  bindSwitch(e: MouseEvent) {
    e.preventDefault();
    return false;
  }
}
